import { render, staticRenderFns } from "./index.vue?vue&type=template&id=250babf6&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=250babf6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "250babf6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yinpeng/Sites/gitlab/layaair-pro-web/performance/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('250babf6')) {
      api.createRecord('250babf6', component.options)
    } else {
      api.reload('250babf6', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=250babf6&scoped=true&", function () {
      api.rerender('250babf6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/UploadImg/index.vue"
export default component.exports